/* eslint-disable import/no-anonymous-default-export */
export default {
  //     dev - http://18.212.62.249/api
  // prod - https://api.bookwedgo.com/api,
  // service: "https://api.bookwedgo.com/api",
  // service: "https://apiprod.bookwedgo.com/api",
  service: "https://apiprod.bookwedgo.com/api",
  // devservice: "http://127.0.0.1:8000/api",
  // service: "http://127.0.0.1:8000/api",
  // vservice:"http://192.168.0.108:8000/api"
};
